<template>
  <CRow>
    <CCol col="12">
      <CCard>
        <CCardHeader>
          <CRow>
            <CCol sm="7">
              <h4 id="traffic" class="card-title mb-0">Meta Info List</h4>
            </CCol>
            <CCol sm="5" class="d-none d-md-block"></CCol>
          </CRow>
        </CCardHeader>
        <CCardBody>
          <CRow>
            <CCol>
              <CButton
                  color="primary"
                  class="float-left mb-2 ml-3"
                  @click="metaInfoCreate"
              >Create</CButton
              >
            </CCol>
            <CCol sm="5" class="d-none d-md-block"></CCol>
            <CRow class="float-right">
              <div class="search-list">
                <CCol sm="12">
                  <CInput
                      class="float-left mb-0 mr-2"
                      placeholder="Search By Meta Info Page"
                      @input="searchMetaInfo($event, '')"
                  >
                    <template #prepend-content>
                      <CIcon name="cil-magnifying-glass" />
                    </template>
                  </CInput>
                </CCol>
              </div>
            </CRow>
          </CRow>
          <CDataTable
              hover
              striped
              :items="items"
              :fields="fields"
              :items-per-page="100"
              clickable-rows
              :active-page="1"
              :pagination="false"
              @page-change="pageChange"
          >
            <template #meta_info_ids="data">
              <td>
                <div class="button-table">
                  <CButton
                      color="primary"
                      class="mb-0 mr-0"
                      @click="rowClicked(data.item.meta_info_id)"
                  >Edit</CButton
                  >
                </div>
              </td>
            </template>
          </CDataTable>
          <div class="pagination-nav">
            <div
                class="pagination-btn-refresh"
                @click="searchMetaInfo('', 'REFRESH')"
            >
              Refresh
            </div>
            <div
                class="pagination-btn-back"
                @click="searchMetaInfo('', 'BACK')"
            >
              back
            </div>
            <div class="pagination-page-title">{{ activePage }}</div>
            <div
                class="pagination-btn-next"
                @click="searchMetaInfo('', 'NEXT')"
            >
              next
            </div>
          </div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from "axios";
import jwt from "jsonwebtoken";

export default {
  name: "MetaInfo",
  data() {
    return {
      items: [],
      fields: [
        { key: "meta_info_id", label: "ID" },
        { key: "meta_info_page", label: "Page" },
        { key: "meta_info_title", label: "Title" },
        { key: "meta_info_ids", label: "Action" },
      ],
      activePage: 1,
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
    };
  },
  mounted() {
    this.authentication();
    this.searchMetaInfo("", "");
  },

  methods: {
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
          data.account_group === "MARKETING" ||
          data.account_group === "ADMIN" ||
          data.account_group === "ADMINISTRATOR"
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
    getBadge(status) {
      switch (status) {
        case "NEW":
          return "success";
        case "FOLLOW UP":
          return "secondary";
      }
    },
    searchMetaInfo(value, action) {
      let activePage = this.activePage;
      if (action === "NEXT") {
        activePage = activePage + 1;
      } else if (action === "BACK") {
        if (activePage > 1) {
          activePage = activePage - 1;
          window.scrollTo(0, 0);
        }
      } else if (action === "REFRESH") {
        activePage = 1;
        window.scrollTo(0, 0);
      } else {
        activePage = 1;
      }

      let url =  `${this.domain}/v1/meta_info/data?page=${activePage}&per_page=20`;
      if(value){
        url = url+ `&q=${value}`;
      }
      axios
          .get(
              url,
              {
                headers: {
                  Authorization: this.token,
                  "Content-Type": "application/json",
                },
              }
          )
          .then((response) => {
            if (response.data.data.length > 0) {
              if (activePage > 1) {
                window.scrollTo(0, 0);
              }
              this.items = response.data.data;
            } else if (action === "NEXT") {
              activePage = activePage - 1;
            } else if (response.data.data.length === 0 && action === "") {
              this.items = response.data.data;
            }
            this.activePage =activePage
          })
          .catch((e) => {
            console.log(e);
          });
    },
    rowClicked(item) {
      this.$router.push({ path: `/management/meta-info/${item}` });
    },
    pageChange(val) {
      this.$router.push({ query: { page: val } });
    },
    metaInfoCreate() {
      this.$router.push({ path: `/management/meta-info/create` });
    },
  },
};
</script>

<style scoped>
@import url("./MetaInfo.css");
</style>
